export default class {
	constructor() {
		this.hoverTargets = [
			{ hover: '.js-hoverTxt01', show: '.js-recruit01', hide: ['.js-recruit02', '.js-recruit03'] },
			{ hover: '.js-hoverTxt02', show: '.js-recruit02', hide: ['.js-recruit01', '.js-recruit03'] },
			{ hover: '.js-hoverTxt03', show: '.js-recruit03', hide: ['.js-recruit01', '.js-recruit02'] },
		];
		this.init();
	}

	init() {
		this.hoverTargets.forEach(target => {
			const hoverElement = document.querySelector(target.hover);
			hoverElement.addEventListener('mouseover', () => this.handleMouseOver(target));
		});
	}

	handleMouseOver(target) {
		document.querySelector(target.show).style.opacity = 1;
		target.hide.forEach(hideSelector => {
			document.querySelector(hideSelector).style.opacity = 0;
		});
	}
}
